/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
/* Services */
// import MomUi from '@moms/Ui/MomUi';
import { getLocale } from '@moms/Utility/Shared/SharedService';
import { performRequest } from '@utils/microsites/DatoCMSHelperService';
import { getMenuQuery, getQuery } from '@utils/microsites/MOMGqlQueries';
const MomUi = dynamic(() => import('@moms/Ui/MomUi'), {
  loading: () => <div>Loading...</div>,
});
/**
 *
 * @param {Object} pageData
 * @returns
 */
const MoMLang = ({ pageData, region, language, firstLevel }) => {
  // console.log(firstLevel, 'first');
  // console.log(pageData, 'pagedata');
  return (
    <Box w="100%" float="left" pos="relative">
      <WrapLayout pageData={pageData}>
        <HeadComponent
          data={pageData?._seoMetaTags || pageData?.seoFields}
          availableLocals={pageData?.availableLocales}
        >
          {' '}
        </HeadComponent>
        <Box w="100%" float="left" pos="relative">
          <Box>
            <MomUi
              pageData={pageData}
              region={region}
              lang={language}
              firstLevel={firstLevel}
            />
          </Box>
        </Box>
      </WrapLayout>
    </Box>
  );
};
export const getStaticPaths = async () => {
  const othersLandingPaths = [
    '/in/en/miracle-of-mind/blogs',
    '/in/en/miracle-of-mind/movement',
    '/in/en/miracle-of-mind/collaborations',
    '/in/en/miracle-of-mind/toolkit',

    '/in/hi/miracle-of-mind/blogs',
    '/in/hi/miracle-of-mind/movement',
    '/in/hi/miracle-of-mind/collaborations',
    '/in/hi/miracle-of-mind/toolkit',

    '/in/ta/miracle-of-mind/blogs',
    '/in/ta/miracle-of-mind/movement',
    '/in/ta/miracle-of-mind/collaborations',
    '/in/ta/miracle-of-mind/toolkit',

    '/ca/en/miracle-of-mind/blogs',
    '/ca/en/miracle-of-mind/movement',
    '/ca/en/miracle-of-mind/collaborations',
    '/ca/en/miracle-of-mind/toolkit',

    '/us/en/miracle-of-mind/blogs',
    '/us/en/miracle-of-mind/movement',
    '/us/en/miracle-of-mind/collaborations',
    '/us/en/miracle-of-mind/toolkit',

    '/sg/en/miracle-of-mind/blogs',
    '/sg/en/miracle-of-mind/movement',
    '/sg/en/miracle-of-mind/collaborations',
    '/sg/en/miracle-of-mind/toolkit',

    '/au/en/miracle-of-mind/blogs',
    '/au/en/miracle-of-mind/movement',
    '/au/en/miracle-of-mind/collaborations',
    '/au/en/miracle-of-mind/toolkit',

    '/uk/en/miracle-of-mind/blogs',
    '/uk/en/miracle-of-mind/movement',
    '/uk/en/miracle-of-mind/collaborations',
    '/uk/en/miracle-of-mind/toolkit',

    '/my/en/miracle-of-mind/blogs',
    '/my/en/miracle-of-mind/movement',
    '/my/en/miracle-of-mind/collaborations',
    '/my/en/miracle-of-mind/toolkit',

    '/global/en/miracle-of-mind/blogs',
    '/global/en/miracle-of-mind/movement',
    '/global/en/miracle-of-mind/collaborations',
    '/global/en/miracle-of-mind/toolkit',

    '/global/fr/miracle-of-mind/blogs',
    '/global/fr/miracle-of-mind/movement',
    '/global/fr/miracle-of-mind/collaborations',
    '/global/fr/miracle-of-mind/toolkit',

    '/global/zh/miracle-of-mind/blogs',
    '/global/zh/miracle-of-mind/movement',
    '/global/zh/miracle-of-mind/collaborations',
    '/global/zh/miracle-of-mind/toolkit',

    '/global/de/miracle-of-mind/blogs',
    '/global/de/miracle-of-mind/movement',
    '/global/de/miracle-of-mind/collaborations',
    '/global/de/miracle-of-mind/toolkit',

    '/global/it/miracle-of-mind/blogs',
    '/global/it/miracle-of-mind/movement',
    '/global/it/miracle-of-mind/collaborations',
    '/global/it/miracle-of-mind/toolkit',

    '/global/es/miracle-of-mind/blogs',
    '/global/es/miracle-of-mind/movement',
    '/global/es/miracle-of-mind/collaborations',
    '/global/es/miracle-of-mind/toolkit',

    '/global/ru/miracle-of-mind/blogs',
    '/global/ru/miracle-of-mind/movement',
    '/global/ru/miracle-of-mind/collaborations',
    '/global/ru/miracle-of-mind/toolkit',
  ];

  return {
    paths: othersLandingPaths,
    fallback: false,
  };
};
export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, firstLevel },
  req,
}) => {
  const headerMenuData = await performRequest(
    getMenuQuery('mommainmenu', getLocale(region, language)),
    'mommainmenu'
  );
  const footerData = await performRequest(
    getMenuQuery('momfooter', getLocale(region, language)),
    'momfooter'
  );
  const response = await performRequest(
    getQuery(`miracle-of-mind/${firstLevel}`, getLocale(region, language))
  );
  // console.log(response, 'respn');
  let pageData = response.allMiracleOfMinds[0] || [];
  // console.log(pageData);
  // let pageData = response?.allShivangaLandingPages;

  pageData = JSON.stringify(pageData).replace(
    /https:\/\/www.datocms-assets.com\//g,
    `${config.staticPath}/d/`
  );
  pageData = JSON.parse(pageData);

  return {
    props: {
      headerMenuData: headerMenuData || null,
      pageData: pageData || '',
      firstLevel: firstLevel,
      footerData: footerData || null,
      isPreview: preview ? true : false,
      region: region,
      language: language,
      menuType: 'shivangamainmenu',
    },
  };
};

export default MoMLang;
